/**
 * Sidebar Content Navigation
 * Automatically marks current page as active in sidebar navigation
 */

(function () {
    'use strict';

    // Get all sidebar navigation links
    const sidebarNavLinks = document.querySelectorAll('.sidebar-nav-link');

    if (!sidebarNavLinks.length) {
        return;
    }

    // Get current page URL and path
    const currentUrl = window.location.href;
    const currentPath = window.location.pathname;

    sidebarNavLinks.forEach(link => {
        const href = link.getAttribute('href');

        if (!href) return;

        // Skip anchor links (same-page navigation)
        if (href.startsWith('#')) return;

        // Check if this link matches the current page
        // Handle both absolute URLs and relative paths
        const isCurrentPage = href === currentUrl ||
            href === currentPath ||
            href.endsWith(currentPath) ||
            (currentPath !== '/' && href.includes(currentPath));

        if (isCurrentPage) {
            link.classList.add('active');
        }
    });

})();
